import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { getIsVolumeOn } from '../../../store/commonSlice'
import { registerResource, resolveResource } from '../../../store/screenSlice'
import { getVideoType } from '../utils'
import styles from '../VideoScreen.module.scss'


class ChromeVideoBody extends Component {
    constructor(props, context) {
        super(props, context)

        this.videoRef = React.createRef()
    }

    componentDidMount() {
        const { playing, videoSrc, isVolumeOn, registerResource } = this.props

        registerResource(videoSrc)
        this.videoRef.current.volume = isVolumeOn ? 1 : 0

        if (playing) {
            this.videoRef.current.play()
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { isVolumeOn, playing } = this.props

        if (isVolumeOn !== nextProps.isVolumeOn) {
            this.videoRef.current.volume = nextProps.isVolumeOn ? 1 : 0
        }

        if (!playing && nextProps.playing) {
            this.videoRef.current.play()
        }

        return false
    }

    resolveResourceHandler = () => {
        const { videoSrc, resolveResource } = this.props

        resolveResource(videoSrc)
    }

    onTimeUpdateHandler = (ev) => {
        const { onTimeUpdate } = this.props

        onTimeUpdate(ev.target)
    }

    render() {
        const { videoSrc } = this.props
        const videoType = getVideoType(videoSrc)

        return (
            <video
                ref={this.videoRef}
                className={styles.video}
                onLoadedData={this.resolveResourceHandler}
                onLoad={this.resolveResourceHandler}
                onError={this.resolveResourceHandler}
                preload="auto"
                playsInline
                onTimeUpdate={this.onTimeUpdateHandler}
            >
                <track kind="captions" />
                <source src={videoSrc} type={videoType} />
            </video>
        )
    }
}

ChromeVideoBody.propTypes = {
    isVolumeOn: PropTypes.bool.isRequired,
    playing: PropTypes.bool.isRequired,
    videoSrc: PropTypes.string.isRequired,
    onTimeUpdate: PropTypes.func.isRequired,
    registerResource: PropTypes.func.isRequired,
    resolveResource: PropTypes.func.isRequired,
}

const ChromeVideo = connect(
    state => ({
        isVolumeOn: getIsVolumeOn(state),
    }), {
        registerResource,
        resolveResource,
    },
)(ChromeVideoBody)

ChromeVideo.propTypes = {
    playing: PropTypes.bool.isRequired,
    videoSrc: PropTypes.string.isRequired,
    onTimeUpdate: PropTypes.func.isRequired,
}

export { ChromeVideo }
